import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ScaleLogo from '../../assets/scale-balance.svg';

export default function ResearchLoader({ isDarkMode, researchStep }) {
  return (
    <div
      className={`relative rounded-2xl px-3 py-2 ${
        isDarkMode ? 'bg-gray-700' : 'bg-white'
      }`}
    >
      <div className="flex items-start mb-1">
        <div className="p-1 rounded-full bg-brandLighter shadow-sm w-6 h-6 flex items-center justify-center">
          <img src={ScaleLogo} alt="Scale" className="w-4 h-4" />
        </div>

        <div className="ml-2 text-sm w-full">
          <div className="flex items-center space-x-2 mb-1">
            <span className="font-semibold text-brand">Researching</span>
            <div className="flex space-x-1.5 py-0.5">
              <div className="h-1.5 w-1.5 bg-brand rounded-full animate-bounce"></div>
              <div
                className="h-1.5 w-1.5 bg-brand rounded-full animate-bounce"
                style={{ animationDelay: '0.2s' }}
              ></div>
              <div
                className="h-1.5 w-1.5 bg-brand rounded-full animate-bounce"
                style={{ animationDelay: '0.4s' }}
              ></div>
            </div>
          </div>

          <div className="w-full max-w-xs">
            <div className="h-1 bg-gray-200 rounded-full overflow-hidden w-full">
              <motion.div
                initial={{ width: '0%' }}
                animate={{
                  width:
                    researchStep === 1
                      ? '20%'
                      : researchStep === 2
                        ? '70%'
                        : researchStep === 3
                          ? '100%'
                          : '0%',
                }}
                transition={{ duration: 0.5, ease: 'easeOut' }}
                className="h-1.5 bg-brand"
              />
            </div>

            <div className="mt-1 min-h-[1.5rem] text-xs font-medium text-gray-600 dark:text-gray-300 text-center">
              <AnimatePresence mode="wait">
                {researchStep === 1 && (
                  <motion.div
                    key="step1"
                    initial={{ opacity: 0, y: 4 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -4 }}
                    transition={{ duration: 0.3 }}
                  >
                    Preparing legal team — about 6-9 minutes left…
                  </motion.div>
                )}

                {researchStep === 2 && (
                  <motion.div
                    key="step2"
                    initial={{ opacity: 0, y: 4 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -4 }}
                    transition={{ duration: 0.3 }}
                  >
                    Analyzing case law — about 3 minutes left…
                  </motion.div>
                )}

                {researchStep === 3 && (
                  <motion.div
                    key="step3"
                    initial={{ opacity: 0, y: 4 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -4 }}
                    transition={{ duration: 0.3 }}
                  >
                    Finalizing research — almost finished now…
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
